import React from "react";
import Text from "@streeteasy/design-system/deprecated/Text";
import { string } from "prop-types";

import {
  AgentBox,
  AgentBoxDetails,
  AgentBoxWrapper,
  LogoImage,
  LogoWrapper,
  TextBold
} from "../../../../styled";

const AgentBoxContent = props => (
  <AgentBoxWrapper>
    <AgentBox href={props.agentUrl}>
      <LogoWrapper>
        <LogoImage alt="logo" src={props.logoUrl} title="logo" />
      </LogoWrapper>
      <AgentBoxDetails>
        <TextBold type="sm">{props.agent}</TextBold>
        <Text type="sm">{props.sourceGroup}</Text>
      </AgentBoxDetails>
    </AgentBox>
  </AgentBoxWrapper>
);

AgentBoxContent.propTypes = {
  agentUrl: string.isRequired,
  agent: string.isRequired,
  logoUrl: string.isRequired,
  sourceGroup: string.isRequired
};

export default AgentBoxContent;
